import { render, staticRenderFns } from "./TicimaxChannels.vue?vue&type=template&id=0a1ef064&scoped=true"
import script from "./TicimaxChannels.vue?vue&type=script&lang=js"
export * from "./TicimaxChannels.vue?vue&type=script&lang=js"
import style0 from "./TicimaxChannels.vue?vue&type=style&index=0&id=0a1ef064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ef064",
  null
  
)

export default component.exports